import {
    RequestConfigFunction,
} from 'app/types/request.types'

type AreaRequests = {
    domainName: string,
    update: RequestConfigFunction<{id: number}>,
    get: RequestConfigFunction<{id: number}>,
}

const areaRequests: AreaRequests = {
    domainName: 'Area',
    update: ({
        id,
    }) => {
        return {
            url: `area/${id}`,
            method: 'PATCH',
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `area/${id}`,
            method: 'GET',
        }
    },
}

export default areaRequests
